/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestDto } from '../../models/contents-request-dto';
import { CreateContentsRequestDto } from '../../models/create-contents-request-dto';

export interface ContentsRequestControllerCreate$Params {
      body: CreateContentsRequestDto
}

export function contentsRequestControllerCreate(http: HttpClient, rootUrl: string, params: ContentsRequestControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestDto>;
    })
  );
}

contentsRequestControllerCreate.PATH = '/api/contents-request';
